import { LazyPage, PipelineAddSourceOptionPage } from './-components';
import { createFileRoute } from '@tanstack/react-router';

function PipelineAddSourceOptionRoute() {
  return (
    <LazyPage>
      <PipelineAddSourceOptionPage />
    </LazyPage>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/pipelines/sources/add_/$sourceOptionId')({
  component: PipelineAddSourceOptionRoute,
});
